import { render, staticRenderFns } from "./ProductsIcon.vue?vue&type=template&id=368e3a76&"
import script from "./ProductsIcon.vue?vue&type=script&lang=js&"
export * from "./ProductsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports